import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import styled from 'styled-components';
import { globalStyles } from 'theme/styles';

export const renderTrack = ({ style, ...props }) => {
	const trackStyle = {
		position: 'absolute',
		maxWidth: '100%',
		width: 6,
		transition: 'opacity 200ms ease 0s',
		opacity: 1,
		background: 'transparent',
		bottom: 2,
		top: 2,
		borderRadius: 3,
		right: 0,
		cursor: 'ns-resize',
	};
	return (
		<div
			style={{ ...style, ...trackStyle }}
			{...props}
		/>
	);
};

export const renderThumb = ({ style, ...props }) => {
	const thumbStyle = {
		borderRadius: 15,
		background: globalStyles.colors.easyBLUE['150'],
		opacity: 0.4,
	};
	return (
		<div
			className='scroll-red'
			style={{ ...style, ...thumbStyle }}
			{...props}
		/>
	);
};

export const renderView = ({ style, ...props }) => {
	const viewStyle = {
		marginBottom: -22,
	};
	return (
		<Box
			me={{ base: '0px !important', lg: '-16px !important' }}
			style={{ ...style, ...viewStyle }}
			{...props}
		/>
	);
};

const ContainerBodyTableFlex = styled.div`
	width: 100%;
	overflow-x: auto;
	display: flex;
	justify-content: start;
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 2px grey;
		border-radius: 10px;
	}
	::-webkit-scrollbar-thumb {
		background: ${props =>
			props.color === 'secondary'
				? globalStyles.colors.easyBLUE['175']
				: globalStyles.colors.easyRED['175']};
		border-radius: 10px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: ${props =>
			props.color === 'secondary'
				? globalStyles.colors.easyBLUE['180']
				: globalStyles.colors.easyRED['500']};
	}
	::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}
`;
interface IScrollBarProps {
	children: JSX.Element | JSX.Element[];
	color?: 'primary' | 'secondary';
}
export const ScrollBar = React.forwardRef<HTMLDivElement, IScrollBarProps>(
	({ children, color }, ref) => {
		return (
			<ContainerBodyTableFlex
				ref={ref}
				color={color}
			>
				<Flex
					position={'relative'}
					flexGrow={1}
				>
					{children}
				</Flex>
			</ContainerBodyTableFlex>
		);
	}
);

ScrollBar.displayName = 'ScrollBar';
